module.exports = __webpack_public_path__ + "static/media/burger-expand.c351fbd9.png";